import React, { useState, useEffect, ReactChild } from 'react'
import styled from 'styled-components'
const isMobile = window.innerWidth < 712

export type ChartKeyEntryType = {
  label: string
  type: 'color' | 'icon' | 'none'
  color: string
  size?: number
  icon?: ReactChild
}
const StyledChartKey = styled.div`
  font-size: 15px;
  font-family: var(--font-plex);
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: flex-start;
  line-height: 18px;
  margin-top: 15px;
  margin-bottom: ${isMobile ? '5px' : '15px'};
`

const CallToAction = styled.div`
  /* color: var(--brandblue-bright-2); */
  line-height: 1.3em;
  margin-top: 10px;
  font-size: 12px;
  display: flex;
  align-items: flex-end;
  max-width: ${isMobile ? '300px' : '100%'};
  font-style: italic;
  div {
    height: ${isMobile ? undefined : '11px'};
  }
`
const ArrowIcon = styled.div`
  flex: 0 0 22px;
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: ${isMobile ? '6px' : '11px'};
  img {
    max-width: 22px;
  }
`

export const ChartKey = ({
  entries,
  labels
}: {
  entries: ChartKeyEntryType[]
  labels: string[]
}) => {
  return (
    <StyledChartKey>
      {entries.map((entry, i) => {
        return <Entry key={'Key_ChartKey_Entry_' + i} {...entry} />
      })}

      <CallToAction>
        <ArrowIcon>
          <img src={require('images/icons/icons_arrow.png')} />
        </ArrowIcon>{' '}
        <div>{isMobile ? labels[1] : labels[0]}</div>
      </CallToAction>
    </StyledChartKey>
  )
}

const StyledEntry = styled.div`
  flex: 1 1 ${isMobile ? '100%' : 'auto'};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${isMobile ? '0.5em' : '0'};
`

const Swatch = styled.div<{ color: string; size?: number }>`
  display: inline-block;
  min-width: ${({ size }) => (size ? size + 'px' : '12px')};
  width: ${({ size }) => (size ? size + 'px' : '12px')};
  height: ${({ size }) => (size ? size + 'px' : '12px')};
  background-color: ${({ color }) => color};
  margin-right: 0.5em;
  border-radius: ${({ size }) => (size || 12) / 2 + 'px'};
`
const IconContainer = styled.div<{ color?: string; size?: number }>`
  display: inline-block;
  width: ${({ size }) => (size ? size + 'px' : '12px')};
  height: ${({ size }) => (size ? size + 'px' : '12px')};
  background-color: ${({ color }) => (color ? color : undefined)};
  margin-right: 0.5em;
  svg,
  img {
    max-width: ${({ size }) => (size ? size + 'px' : '12px')};
  }
`
const Label = styled.div`
  flex: 0 0 calc(100% - 30px);
  font-weight: 400;
  padding-left: 5px;
`
const Entry = ({ label, type, color, size, icon }: ChartKeyEntryType) => {
  return (
    <StyledEntry>
      {type === 'color' && <Swatch color={color} size={size} />}
      {type === 'icon' && <IconContainer size={size}>{icon}</IconContainer>}
      <Label>{label}</Label>
    </StyledEntry>
  )
}
